import React, { useEffect, useState } from "react";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useUserContext } from "../../context/UserProvider";
import ChallengesPage from "./ChallengesPage/ChallengesPage";
import { groupChallengesByStatus } from "./ChallengesPage/challengePageUtils";
import DashboardPage from "./DashboardPage";
import LeaderBoardPage from "./LeaderBoardPage";
import StravaConfirmation from "./ConfirmPages/StravaConfirmation";
import FitbitAuth from "./ConfirmPages/FitbitAuth";
import GarminAuth from "./ConfirmPages/GarminAuth";
import AccountPage from "./AccountPage";
import DeleteAccountPage from "./DeleteAccountPage";
import ReferralHub from "./ReferralHub";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import SocialFeed from "./SocialFeed";
import TeamChat from "./TeamChat";
import SocialProfilePage from "./SocialProfilePage/SocialProfilePage";
import { SendPageView } from "../../func/analyticsFunctions";
import SubMenuWrapper, { SubMenuItem } from "../util/SubMenu";
import { CalendarIcon, DumbbellIcon, ListIcon, MedalIcon, MomentumIcon, PlaygroundIcon } from "../util/Icons";
import DropDownMenu from "../util/DropDownMenu";
import MembershipPage from "./MembershipPage";
import StorePage from "./StorePage";
import StoreConfirmationPage from "./StoreConfirmationPage";
import StrongHealthy from "../StrongHealthy"
import PlansMain from "../Plans"
import StreakPage from "./StreakPage";
import WeeklyRecapBanner from "./WeeklyRecapBanner";
import { getChallengeMenuLabel, getFeaturedChallenge } from "./challengeMenuUtils";
import HalloweenDecor from "./HalloweenDecor/HalloweenDecor";
import HomeRaceReady from "../RacePage/RaceReady/HomeRaceReady";
// const dateOptions = {
//   month: "short",
//   day: "2-digit",
//   year: "numeric",
// };

const HomePage = () => {
  const location = useLocation();
  const { userDetails, userData, userRaces, canSocialFeed, userLoading } = useUserContext();
  const [racesMap, setRacesMap] = useState([]);
  const [homeBannerData, setHomeBannerData] = useState(null);
  const [homeBannerMemberData, setHomeBannerMemberData] = useState(null);
  // console.log(loading, homeBannerData);
  useEffect(() => {
    // Set Page Title
    let lo = location.pathname;
    switch (true) {
      case lo === "/":
        document.title = "Main Feed - MCC";
        SendPageView("Main Feed - MCC");
        break;
      case lo === "/challenges":
        document.title = "Your Challenges - MCC";
        SendPageView("Your Challenges - MCC");
        break;
      case lo === "/account":
        document.title = "Account Settings";
        SendPageView("Account Settings");
        break;
      case lo === "/account/delete":
        document.title = "Delete Account";
        SendPageView("Delete Account");
        break;
      case lo === "/referralhub":
        document.title = "Referral Hub";
        SendPageView("Referral Hub");
        break;
      case lo.startsWith("/dashboard"):
        if (!userRaces) break;
        let da_raceID = lo.split("/dashboard/")[1];
        let da_raceData = userRaces?.get("price_" + da_raceID);
        let da_raceName = da_raceData?.raceInfo?.name;
        document.title = "Dashboard - " + da_raceName;
        SendPageView("Dashboard - " + da_raceName);
        break;
      case lo.startsWith("/leaderboard"):
        if (!userRaces) break;
        let le_raceID = lo.split("/leaderboard/")[1];
        let le_raceData = userRaces?.get("price_" + le_raceID);
        let le_raceName = le_raceData?.raceInfo?.name;
        document.title = "Leaderboard - " + le_raceName;
        SendPageView("Leaderboard - " + le_raceName);
        break;
      case lo === "/garminAuth":
        document.title = "Garmin Confirmation";
        SendPageView("Garmin Confirmation");
        break;
      case lo === "/fitbitAuth":
        document.title = "Fitbit Confirmation";
        SendPageView("Fitbit Confirmation");
        break;
      case lo === "/sconfirm":
        document.title = "Strava Confirmation";
        SendPageView("Strava Confirmation");
        break;
      case lo === "/memberhsip":
        document.title = "Membership Page";
        SendPageView("Membership Page");
        break;
      case lo === "/streaks":
        document.title = "Streaks - MCC";
        SendPageView("Streaks - MCC");
        break;
      case lo === "/store":
        document.title = "Store - MCC";
        SendPageView("Store - MCC");
        break;
      case lo.startsWith("/store/confirmation"):
        document.title = "Store Order Confirmed - MCC";
        SendPageView("Store Order Confirmed - MCC");
        break;
      case lo.startsWith("/team-chat"):
        document.title = "Team Chat - MCC";
        SendPageView("Team Chat - MCC");
        break;
      case lo === "/strong-healthy":
        document.title = "Health Hub - MCC";
        SendPageView("Health Hub - MCC");
        break;
      case lo === "/strong-healthy/strength-training":
        document.title = "Strength Training - MCC";
        SendPageView("Strength Training - MCC");
        break;
      case lo === "/strong-healthy/mobility":
        document.title = "Mobility Program - MCC";
        SendPageView("Mobility Program - MCC");
        break;
      case lo === "/strong-healthy/oneHundred":
        document.title = "101 Body Weight Exercises - MCC";
        SendPageView("101 Body Weight Exercises - MCC");
        break;
      case lo === "/strong-healthy/calorie-deficit-calculator":
        document.title = "Calorie Deficit Calculator - MCC";
        SendPageView("Calorie Deficit Calculator - MCC");
        break;
      case lo.startsWith("/strong-healthy/monthly-meetups"):
        document.title = "Monthly Meetups - MCC";
        SendPageView("Monthly Meetups - MCC");
        break;
      // Not necessary because social profile page is already doing this
      // case lo.startsWith("/profile/"):
      //   document.title = "Social Profile - MCC";
      //   SendPageView("Social Profile - MCC");
      //   break;
    }
    // console.log(location, document.title);
  }, [location.pathname, userRaces]);

  useEffect(() => {
    initHomeBanner();

    async function initHomeBanner() {
      const bannerDoc = await getDoc(doc(db, "options", "homeBanner"));
      const bannerData = bannerDoc.data();
      setHomeBannerData({
        src: bannerData.image_url,
        alt: bannerData.image_alt,
        title: bannerData.image_alt,
        href: bannerData.image_link,
        // options/homeBanner.active: false swaps this banner for the race-ready checklist. Missing counts as true.
        active: bannerData.active !== false,
      });

      const memberBannerDoc = await getDoc(doc(db, "options", "homeBannerMembers"));
      if (memberBannerDoc.exists()) {
        const memberData = memberBannerDoc.data();
        setHomeBannerMemberData({
          src: memberData.image_url_m,
          alt: memberData.image_alt_m,
          title: memberData.image_alt_m,
          href: memberData.image_link_m,
          // Its own switch, separate from options/homeBanner. Missing counts as true.
          active: memberData.active !== false,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (userRaces) {
      const groupedChallenges = groupChallengesByStatus(
        userRaces,
        Date.now(),
        userData?.timeZone || ""
      );
      const orderedRaces = [
        ...groupedChallenges.current,
        ...groupedChallenges.finished,
        ...groupedChallenges.concluded,
      ];

      setRacesMap(orderedRaces.map((race) => <NewRaceCard race={race} key={race.legId} />));
    }
  }, [userData?.timeZone, userRaces]);

  // if (loading || homeBannerData === null) {
  //   return;
  // }
  if (userLoading) return;
  return (
    <Routes>
      <Route path="" element={<HomeLayout homeBannerData={homeBannerData} homeBannerMemberData={homeBannerMemberData} racesMap={racesMap} />} />
      {canSocialFeed && <Route path="p/:postId" element={<HomeLayout homeBannerData={homeBannerData} homeBannerMemberData={homeBannerMemberData} racesMap={racesMap} />} />}
      <Route path="challenges" element={<ChallengesPage />} />
      <Route path="sconfirm" element={<StravaConfirmation />} />
      <Route path="fitbitAuth" element={<FitbitAuth />} />
      <Route path="garminAuth" element={<GarminAuth />} />

      <Route path="account" element={<AccountPage />} />
      <Route path="account/delete" element={<DeleteAccountPage />} />
      <Route path="referralhub" element={<ReferralHub />} />

      {/* <Route path="stravaTest" element={<StravaTest />} /> */}
      {/* <Route path="fitbitDaily" element={<FitbitGet />} /> */}

      <Route path="dashboard/:raceId" element={<DashboardPage />} />
      <Route path="leaderboard/:raceId" element={<LeaderBoardPage />} />
      <Route path="profile/:uid" element={<SocialProfilePage />} />
      <Route path="membership" element={<MembershipPage />} />
      <Route path="store" element={<StorePage />} />
      <Route path="store/confirmation" element={<StoreConfirmationPage />} />
      <Route path="streaks" element={<StreakPage />} />
      <Route path="team-chat" element={<TeamChat />} />
      <Route path="team-chat/:chatId" element={<TeamChat />} />
      <Route path="strong-healthy/*" element={<StrongHealthy />} />
      <Route path="training-plans/*" element={<PlansMain />} />
      <Route path="*" element={<Navigate to="createaccount" replace={true} />} />
    </Routes>
  );
};

function HomeLayout({ homeBannerData, homeBannerMemberData, racesMap }) {
  const { user, userDetails, userData, canSocialFeed, userRaces, membership } = useUserContext();
  const activeBanner = (membership && homeBannerMemberData) ? homeBannerMemberData : homeBannerData;
  // Reminder emails link to /?challenge-ready=<dashboard id>: open that challenge's checklist even when the banner is on.
  const location = useLocation();
  const challengeReadyFocus = new URLSearchParams(location.search).get("challenge-ready");
  const [socialFeedNoAccess, setSocialFeedNoAccess] = useState({
    title: "You need to be registered to a race to access the Social Feed",
    button_url: "https://race.mychallengecanada.ca/register/60northrun26",
    button_text: "You can register to The 60° North Run Here",
  });

  // Fetch socialFeedNoAccess data from Firestore
  useEffect(() => {
    async function fetchSocialFeedNoAccess() {
      try {
        const docSnap = await getDoc(doc(db, "options", "socialFeedNoAccess"));
        if (docSnap.exists()) {
          const data = docSnap.data();
          setSocialFeedNoAccess((prev) => ({
            title: data.title ?? prev.title,
            button_url: data.button_url ?? prev.button_url,
            button_text: data.button_text ?? prev.button_text,
          }));
        }
      } catch (error) {
        console.error("Error fetching socialFeedNoAccess:", error);
      }
    }
    fetchSocialFeedNoAccess();
  }, []);

  const featuredChallenge = getFeaturedChallenge(
    userRaces,
    Date.now(),
    userData?.timeZone || ""
  );

  return (
    <div className="mt-3 max-w-4xl md:w-full pb-1 mx-auto">
      <>
        {/* Banner, or the race-ready checklist when the banner is turned off */}
        {activeBanner?.active === false || challengeReadyFocus ? (
          <HomeRaceReady focusDashboardId={challengeReadyFocus} />
        ) : (
          <Link className="" to={activeBanner?.href} target="_blank">
            <img
              className="w-full h-auto mb-2 bg-slate-300 cursor-pointer"
              src={activeBanner?.src}
              alt={activeBanner?.alt}
              title={activeBanner?.title}
            />
          </Link>
        )}

        {/* SubMenu - below banner */}
        <SubMenuWrapper decoration={<HalloweenDecor />}>
          <ChallengeMenuItem race={featuredChallenge} />
          <SubMenuItem icon={<ListIcon size={20} color="#3b82f6" />} label={"Challenges"} to="/challenges" />
          <SubMenuItem icon={<PlaygroundIcon size={20} color="#8b5cf6" />} label={"Playground"} to={"/image-generator"} />
          <MomentumMenu />
        </SubMenuWrapper>

        {/* Main Content - Social Feed centered and larger */}
        <div className="flex flex-col items-center justify-center w-full">
          {/* Social Feed - Full width and centered */}
          <WeeklyRecapBanner user={user} userDetails={userDetails} userRaces={userRaces} />

          {canSocialFeed && (
            <div className="w-full max-w-3xl mx-auto">
              <SocialFeed></SocialFeed>
            </div>
          )}
          {!canSocialFeed && (
            <div className="relative w-full max-w-3xl mx-auto">
              <img src="/img/feed-blocked.png" alt="Blocked Feed" className="w-full h-auto" />
              <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-start pt-20 px-4">
                <h3 className="text-center font-bold text-xl mb-4 text-black drop-shadow-md">
                  {socialFeedNoAccess.title}
                </h3>
                <a
                  href={socialFeedNoAccess.button_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-2 text-white font-semibold rounded hover:opacity-90 transition-opacity text-center"
                  style={{ backgroundColor: "#006bc1" }}
                >
                  {socialFeedNoAccess.button_text}
                </a>
              </div>
            </div>
          )}
        </div>
      </>
    </div>
  );
}

function ChallengeMenuItem({ race }) {
  const dashboardId = race?.legId?.replace(/^price_/, "");

  if (!dashboardId) {
    return null;
  }

  const imageUrl = race?.raceInfo?.imageUrl;
  const label = getChallengeMenuLabel(race);
  const icon = imageUrl ? (
    <img src={imageUrl} alt="" className="w-6 h-6 object-contain rounded-full" />
  ) : (
    <MedalIcon size={20} color="#0f766e" />
  );

  return <SubMenuItem icon={icon} label={label} to={`/dashboard/${dashboardId}`} />;
}

function MomentumMenu() {
  return (
    <div className="relative flex flex-col items-center">
      <DropDownMenu
        trigger={({ ref, onClick, open }) => (
          <button onPointerDown={onClick} ref={ref} className="flex flex-col items-center cursor-pointer bg-transparent border-none p-0">
            <div
              className={`w-7 h-7 flex items-center justify-center rounded-full transition-colors ${
                open ? "bg-gray-200" : "bg-gray-100 hover:bg-gray-200"
              }`}
            >
              <MomentumIcon size={20} color="#ef4444" />
            </div>
            <span className="text-[10px] text-gray-600 mt-0.5 text-center leading-tight max-w-[60px]">
              Momentum
            </span>
          </button>
        )}
      >
        <div className="mt-2 w-36 rounded-lg border border-gray-100 bg-white p-1 shadow-lg">
          <MomentumMenuLink to="/strong-healthy" icon={<DumbbellIcon size={16} color="#ef4444" />}>
            Health Hub
          </MomentumMenuLink>
          <MomentumMenuLink to="/training-plans" icon={<CalendarIcon size={16} color="#f97316" />}>
            Plans
          </MomentumMenuLink>
        </div>
      </DropDownMenu>
    </div>
  );
}

function MomentumMenuLink({ to, icon, children }) {
  return (
    <Link to={to} className="flex items-center gap-2 rounded-md px-2 py-2 text-sm font-medium text-gray-700 no-underline hover:bg-gray-100">
      {icon}
      <span>{children}</span>
    </Link>
  );
}

function NewRaceCard({ race }) {
  return (
    <div className="relative flex flex-row items-center border border-gray-300 rounded-xl p-2 w-full gap-2 bg-white shadow-sm hover:shadow-md transition-shadow">
      <div className="flex-shrink-0">
        <img className="w-[50px] h-[50px] object-contain" src={race.raceInfo?.imageUrl} alt={`${race.raceInfo?.name}-logo`} />
      </div>
      <div className="flex flex-col flex-1 items-center justify-center">
        <p className="font-bold text-base mb-1 text-center text-black leading-tight w-full">{race.raceInfo?.name}</p>
        <Link
          className="text-xs cursor-pointer py-1 px-4 rounded-md w-2/3 text-center text-white transition-opacity hover:opacity-90"
          style={{ backgroundColor: "#006bc1" }}
          to={`/dashboard/${race.legId.replace(/^price_/, "")}`}
        >
          Dashboard
        </Link>
      </div>
    </div>
  );
}

function RacesMap({ userRaces }) {
  let racesByStatus = {
    ongoing: [],
    upcoming: [],
    concluded: [],
  };
  function temp() {
    if (!(userRaces instanceof Map)) {
      console.warn("User races isn't map");
      return;
    }
    if (userRaces.size === 0) {
      console.log("No subscribed races");
    }
    userRaces.forEach((race) => {
      const info = race?.raceInfo || {};
      const localDatePolicy = info.activityDatePolicy === "participant_local_v1";
      const todayKey = new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date());
      const raceStatus = localDatePolicy
        ? todayKey < info.activityStartDate ? "upcoming" : todayKey > info.activityEndDate ? "concluded" : "ongoing"
        : isDateBetween(new Date(info.raceDateStart), new Date(info.raceDateEnd), new Date());
      switch (raceStatus) {
        case "ongoing":
          racesByStatus.ongoing.push(race);
          break;
        case "upcoming":
          racesByStatus.upcoming.push(race);
          break;
        case "concluded":
          racesByStatus.concluded.push(race);
          break;
        default:
          console.log("Couldn't find race status", race);
          break;
      }
    });

    // console.log(racesByStatus);
  }
  temp();

  if (racesByStatus.concluded.length > 0) {
    racesByStatus.concluded.sort((a, b) => {
      return dateSort(a, b);
    });
  }
  return (
    <div>
      {racesByStatus.ongoing.length > 0 && (
        <div>
          <StatusDropDown color="rgb(69, 236, 69)" text="Ongoing Races">
            <div className="pb-2">
              {racesByStatus?.ongoing.map((race) => {
                let info = race?.raceInfo;
                return (
                  <div key={info?.name + race?.bibNumber} className="flex flex-col w-1/2 min-w-fit items-center border relative">
                    {race?.completedDate && (
                      <div className="bg-green-700 px-2 absolute  top-6 left-16 rotate-12">
                        <h6 className="font-semibold m-0 text-white">FINSHER</h6>
                      </div>
                    )}
                    <img src={info.imageUrl} alt="" className="w-28" />
                    <p className="mb-0">{info?.name}</p>
                    <p className="mb-0">{info?.legName}</p>
                    <p className="mb-0">BIB: {race?.bibNumber}</p>
                    {race?.teamName !== "noTeam" && <p className="mb-0">Team: {race?.teamName}</p>}
                    <p className="mb-0">Distance: {info?.distance}km</p>
                    <p className="mb-0">Progress: 0%</p>
                    <div id="buttons" className="grid grid-cols-2 gap-2 items-center place-items-center py-2 text-center">
                      <Link
                        className="text-sm cursor-pointer mb-0 text-center w-full border content-center"
                        to={`/dashboard/${race?.legId.replace(/^price_/, "")}`}
                      >
                        My Challenge Dashboard
                      </Link>
                      <Link
                        className="text-sm cursor-pointer mb-0 text-center w-full border h-full content-center"
                        to={`/leaderboard/${race?.legId.replace(/^price_/, "")}`}
                      >
                        View LeaderBoard
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </StatusDropDown>
        </div>
      )}
      {racesByStatus.upcoming.length > 0 && (
        <div>
          <StatusDropDown color="rgb(255, 179, 41)" text="Up Next">
            <div>
              {racesByStatus.upcoming.map((race) => {
                let info = race?.raceInfo;
                // console.log(race);
                return (
                  <div
                    key={info?.name + race?.bibNumber}
                    className="mb-2 pb-1 relative"
                    style={{
                      borderBottom: "1px solid black",
                      borderRight: "1px solid black",
                    }}
                  >
                    <div className="grid grid-cols-[56px,1fr] gap-2">
                      <div>
                        <img src={info?.imageUrl} alt="" />
                      </div>
                      <div className="grid grid-cols-2 items-center">
                        <p className="mb-0">{info?.name}</p>
                        <p className="mb-0 text-green-700 self-center text-center row-span-2">Starting on {info?.userStartDate}</p>
                        <div className="flex flex-wrap text-sm gap-1">
                          <span>Leg: {info?.legName} </span>
                          <span> | Distance: {info?.distance}km </span>
                          <span> | BIB: {race?.bibNumber} </span>
                          {race?.teamName !== "noTeam" && <span> | Team: {race?.teamName}</span>}
                        </div>
                      </div>
                    </div>
                    <div id="buttons" className="grid grid-cols-2 gap-2 items-center place-items-center py-2">
                      <Link
                        className="text-sm cursor-pointer mb-0 text-center w-full"
                        to={`/dashboard/${race?.legId.replace(/^price_/, "")}`}
                      >
                        My Challenge Dashboard
                      </Link>
                      <Link
                        className="text-sm cursor-pointer mb-0 text-center w-full"
                        to={`/leaderboard/${race?.legId.replace(/^price_/, "")}`}
                      >
                        View LeaderBoard
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </StatusDropDown>
        </div>
      )}
      {racesByStatus.concluded.length > 0 && (
        <div>
          <StatusDropDown color="rgb(179, 177, 177)" text="Concluded" active={false}>
            <div>
              {racesByStatus.concluded.map((race) => {
                let info = race?.raceInfo;
                // console.log(race);
                return (
                  <div
                    key={info?.name + race?.bibNumber}
                    className="mb-2 pb-1 relative"
                    style={{
                      borderBottom: "1px solid black",
                      borderRight: "1px solid black",
                    }}
                  >
                    {race?.completedDate && (
                      <div className="bg-green-700 px-2 mb-1 mt-3">
                        <h6 className="font-semibold m-0 text-white">FINSHER</h6>
                      </div>
                    )}
                    <div className="grid grid-cols-[56px,1fr] gap-2">
                      <div>
                        <img src={info?.imageUrl} alt="" />
                      </div>
                      <div>
                        <p className="mb-0">{info?.name}</p>
                        <div className="flex flex-wrap text-sm gap-1">
                          <span>Leg: {info?.legName} </span>
                          <span> | Distance: {info?.distance}km </span>
                          <span> | BIB: {race?.bibNumber} </span>
                          {race?.teamName !== "noTeam" && <span> | Team: {race?.teamName}</span>}
                        </div>
                        <p className="mb-0 text-sm">Ended on {info?.userEndDate}</p>
                      </div>
                    </div>
                    <div id="buttons" className="grid grid-cols-2 gap-2 items-center place-items-center py-2">
                      <Link
                        className="text-sm cursor-pointer mb-0 text-center w-full"
                        to={`/dashboard/${race?.legId.replace(/^price_/, "")}`}
                      >
                        My Challenge Dashboard
                      </Link>
                      <Link
                        className="text-sm cursor-pointer mb-0 text-center w-full"
                        to={`/leaderboard/${race?.legId.replace(/^price_/, "")}`}
                      >
                        View LeaderBoard
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </StatusDropDown>
        </div>
      )}
    </div>
  );
}

function StatusDropDown({ children, color = "white", text = "", active = true }) {
  let [toggle, setToggle] = useState(active);
  let racesSize = children?.props?.children?.length || 0;
  return (
    <div className="relative">
      <div
        className="text-lg pl-2  cursor-pointer flex items-center mb-2"
        style={{ backgroundColor: color }}
        onClick={() => {
          setToggle(!toggle);
        }}
      >
        <span className="w-2 h-2 rounded-full inline-block mx-1" style={{ backgroundColor: "white" }}></span>
        <span>{text}</span>
        {!toggle && <span className="ml-2 text-sm">(Hidden: {racesSize})</span>}
        <span className="absolute right-1">
          {toggle && "[Hide]"}
          {!toggle && "[Show]"}
        </span>
      </div>
      {toggle && children}
    </div>
  );
}

function dateSort(a, b) {
  const aDate = new Date(a?.raceInfo?.raceDateEnd);
  const bDate = new Date(b?.raceInfo?.raceDateEnd);
  if (aDate.getTime() !== bDate.getTime()) {
    return bDate.getTime() - aDate.getTime();
  }
  return a?.bibNumber - b?.legName?.bibNumber;
}

function isDateBetween(start, end, target) {
  // Convert all dates to milliseconds since Unix epoch
  const startMillis = start.getTime();
  const endMillis = end.getTime();
  const targetMillis = target.getTime();

  if (targetMillis >= endMillis) return "concluded";
  if (targetMillis <= startMillis) return "upcoming";
  if (targetMillis >= startMillis && targetMillis <= endMillis) return "ongoing";
  return "None";
}

export default HomePage;
